const TutorialsVideos = {
  ZOCESPdEYo0: {
    id: "ZOCESPdEYo0",
    title: "Yubikey Log In (New & Existing Users)",
    description:
      "A guide to logging in to Caseworker using a Yubikey as a new or existing user."
  },
  "6DsNkh0QLsg": {
    id: "6DsNkh0QLsg",
    title: "Transferring email from Outlook to Caseworker",
    description:
      "A step by step guide to creating Outlook rules to move emails into your Caseworker inbox."
  },
  Yrcncm6Oa8w: {
    id: "Yrcncm6Oa8w",
    title: "The Caseworker Inbox",
    description:
      "A guide to your Caseworker Inbox covering how to manage casework and campaign emails, and the creation of new constituents and cases from your emails."
  },
  wisN0J1qhRM: {
    id: "wisN0J1qhRM",
    title: "Creating a New Constituent And Case",
    description:
      "A guide to help you create new constiuents in Caseworker when there is not an electoral roll match, and then creating a case for that constituent."
  },
  at0Fxr4Mvcw: {
    id: "at0Fxr4Mvcw",
    title: "Search Box",
    description:
      "A guide to using the Search Box in Caseworker covering how to search for full names, addresses and case references."
  },
  "5YjqwSUi224": {
    id: "5YjqwSUi224",
    title: "Case Page",
    description:
      "A guide to your Caseworker case page covering how to send emails, create letters and adding notes."
  },
  Na_kiidYens: {
    id: "Na_kiidYens",
    title: "Cases Tab",
    description:
      "A guide to your Caseworker cases tab covering how to search for cases, export a mailing list, send a bulk email and add a note en masse."
  },
  "t-ZqDbdDyJk": {
    id: "t-ZqDbdDyJk",
    title: "Third Party Contacts",
    description:
      "A guide to your Caseworker contacts covering how to create organisations and contacts within them."
  },
  "3xY8hJC_GAE": {
    id: "3xY8hJC_GAE",
    title: "Tools Section",
    description:
      "A guide to some of the advanced features within the Caseworker tools section including email templates, door knocking sheets, surgeries and users."
  },
  D7U9tV5Kt0k: {
    id: "D7U9tV5Kt0k",
    title: "Statistics",
    description:
      "An explanation of the statistics page inside your Caseworker installation and how you can use it to monitor what your constituents have contacted you about, the current status of your work, and staff workloads."
  }
};

export default TutorialsVideos;



// WEBPACK FOOTER //
// ./src/content/tutorialsVideos.js